module.exports = __webpack_public_path__ + "img/POT.f531717b.svg";